<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @execute="exeMove" @save="save"
                    @del="del" ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="InvMoveViewInfo"
                        :filter_language="['Order_status']"
                        :header="tableHeader"
                        :option="tableOption"
                        @edits="edits"
                        @rowdblclick="openEdit"
                        ref="singleTable"
                        :checkflg="false"
                ></wTable>
                <!--<el-table
                        :data="dataSet"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        @row-click="edits"
                        @row-dblclick="openEdit"
                        :height="tableHeight"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                        ref="singleTable"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Order_No"
                                     :label="$t('getapi[2430]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Order_status"
                                     :label="$t('getapi[1861]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="keep_account_No"
                                     :label="$t('getapi[2098]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="keep_account_time"
                                     :label="$t('getapi[1748]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="keep_account_person"
                                     :label="$t('getapi[1747]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="dust_person"
                                     :label="$t('getapi[2431]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="move_time"
                                     :label="$t('getapi[2432]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Finance_Date"
                                     :label="$t('getapi[1857]')"></el-table-column>
                </el-table>-->
            </li>

            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="width:800px;min-width:800px">
                    <table>
                        <tr>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2430]') }}</span></td>
                            <td style="width:120px;min-width:120px"><el-input v-model="formInline.Head.order_no" :placeholder="$t('getapi[2430]')"
                                                                               size="mini" :readonly="true" class="readO"></el-input></td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2446]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input
                                        v-if="formInline.Head.order_type_flag == 0"
                                        :placeholder="$t('getapi[2446]')"
                                        :value="$t('getapi[8626]')"
                                        size="mini"
                                        :readonly="true" class="readO"
                                ></el-input>
                                <el-input
                                        v-if="formInline.Head.order_type_flag == 1"
                                        :placeholder="$t('getapi[2446]')"
                                        :value="$t('getapi[8627]')"
                                        size="mini"
                                        :readonly="true" class="readO"
                                ></el-input>
                            </td>
                            <td style="width:80px;min-width:80px">
                                <span>{{ $t('getapi[2098]') }}</span>
                            </td>
                            <td style="width:120px;min-width:120px">
                                <el-input v-model="formInline.Head.keep_account_no" :placeholder="$t('getapi[2098]')" size="mini" :readonly="formInline.Head.order_status == 1 ? true : false" :class="{'readO':formInline.Head.order_status == 1}"></el-input>
                            </td>
                            <td colspan="2"><el-checkbox v-model="showtab" @change="cheshow" style="margin-left:20px;">{{ $t('getapi[2445]')
                                }}
                            </el-checkbox></td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[1748]') }}</span></td>
                            <td><el-input v-model="formInline.Head.keep_account_time" :placeholder="$t('getapi[1748]')"
                                          size="mini" :readonly="true" class="readO"></el-input></td>
                            <td><span>{{ $t('getapi[1747]') }}</span></td>
                            <td><el-input v-model="formInline.Head.keep_account_person" :placeholder="$t('getapi[1747]')"
                                           size="mini" :readonly="true" class="readO"></el-input></td>
                            <td><span>{{ $t('getapi[2431]') }}</span></td>
                            <td><el-input
                                    v-model="formInline.Head.dust_person"
                                    @click.native.prevent="people(scope)"
                                    :placeholder="$t('getapi[2431]')"
                                    size="mini"
                                    :readonly="formInline.Head.order_status == 1 ? true : false"
                            ></el-input></td>
                            <td style="width:80px;min-width:80px">
                                <span>{{ $t('getapi[1857]') }}</span>
                            </td>
                            <td style="width:120px;min-width:120px">
                                <el-input v-model="formInline.Head.finance_date" :placeholder="$t('getapi[1857]')"
                                          size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[2432]') }}</span></td>
                            <td><el-input v-model="formInline.Head.move_time" :placeholder="$t('getapi[2432]')"
                                           size="mini" :readonly="true" class="readO"></el-input></td>
                            <td><span>{{ $t('getapi[1861]') }}</span></td>
                            <td><el-input v-if="formInline.Head.order_status == 0" size="mini" :value="$t('getapi[1422]')"
                                          :readonly="true" class="readO"></el-input>
                                <el-input v-if="formInline.Head.order_status == 1"  size="mini" :value="$t('getapi[3557]')"
                                          :readonly="true" class="readO"></el-input></td>
                            <td><span>{{ $t('getapi[1862]') }}</span></td>
                            <td>
                                <el-input v-if="formInline.Head.finance_status == 0" size="mini" :value="$t('getapi[1901]')"
                                          :readonly="true" class="readO"></el-input>
                                <el-input v-if="formInline.Head.finance_status == 1" size="mini" :value="$t('getapi[3753]')"
                                          :readonly="true" class="readO"></el-input>
                                <el-input v-if="formInline.Head.finance_status == 2" size="mini" :value="$t('getapi[4606]')"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[143]') }}</span></td>
                            <td colspan="7">
                                <el-input
                                        type="textarea"
                                        :rows="2"
                                        v-model="formInline.Head.remark"
                                        :readonly="formInline.Head.order_status == 1 ? true : false"
                                        :class="{'readO':formInline.Head.order_status == 1}"
                                ></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
                <!--<div class="box">
                    <div class="bbl">
                        <span>{{ $t('getapi[2430]') }}</span>
                        <el-input v-model="formInline.Head.order_no" :placeholder="$t('getapi[2430]')"
                                  style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                        <span>{{ $t('getapi[2446]') }}</span>
                        <el-input
                                v-if="formInline.Head.order_type_flag == 0"
                                :placeholder="$t('getapi[2446]')"
                                :value="$t('getapi[8626]')"
                                style="width: 120px"
                                size="mini"
                                :readonly="true" class="readO"
                        ></el-input>
                        <el-input
                                v-if="formInline.Head.order_type_flag == 1"
                                :placeholder="$t('getapi[2446]')"
                                :value="$t('getapi[8627]')"
                                style="width: 120px"
                                size="mini"
                                :readonly="true" class="readO"
                        ></el-input>
                        <span>{{ $t('getapi[2098]') }}</span>
						<el-input v-model="formInline.Head.keep_account_no" :placeholder="$t('getapi[2098]')" style="width: 120px" size="mini" :readonly="formInline.Head.order_status == 1 ? true : false" :class="{'readO':formInline.Head.order_status == 1}"></el-input>
                        <el-checkbox v-model="showtab" @change="cheshow" style="margin-left:20px;">{{ $t('getapi[2445]')
                            }}
                        </el-checkbox>
                    </div>
                    <div class="bbl">
                        <span>{{ $t('getapi[1748]') }}</span>
                        <el-input v-model="formInline.Head.keep_account_time" :placeholder="$t('getapi[1748]')"
                                  style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                        <span>{{ $t('getapi[1747]') }}</span>
                        <el-input v-model="formInline.Head.keep_account_person" :placeholder="$t('getapi[1747]')"
                                  style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                        <span>{{ $t('getapi[2431]') }}</span>
                        <el-input
                                v-model="formInline.Head.dust_person"
                                @click.native.prevent="people(scope)"
                                :placeholder="$t('getapi[2431]')"
                                size="mini"
                                style="width: 120px"
                                :readonly="formInline.Head.order_status == 1 ? true : false"
                        ></el-input>
                        <span>{{ $t('getapi[1857]') }}</span>
                        <el-input v-model="formInline.Head.finance_date" :placeholder="$t('getapi[1857]')"
                                  style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                    </div>
                    <div class="bbl">
                        <span>{{ $t('getapi[2432]') }}</span>
                        <el-input v-model="formInline.Head.move_time" :placeholder="$t('getapi[2432]')"
                                  style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                        <span>{{ $t('getapi[1861]') }}</span>
                        <el-input v-if="formInline.Head.order_status == 0" style="width: 120px" size="mini" :value="$t('getapi[1422]')"
                                  :readonly="true" class="readO"></el-input>
                        <el-input v-if="formInline.Head.order_status == 1" style="width: 120px" size="mini" :value="$t('getapi[3557]')"
                                  :readonly="true" class="readO"></el-input>
                        &lt;!&ndash; <el-input v-model="formInline.Head.order_statu" :placeholder="$t('getapi[1861]')" style="width: 120px" size="mini"></el-input> &ndash;&gt;
                        <span>{{ $t('getapi[1862]') }}</span>
                        &lt;!&ndash; <el-input v-model="formInline.Head.finance_status" :placeholder="$t('getapi[1862]')" style="width: 120px" size="mini"></el-input> &ndash;&gt;
                        <el-input v-if="formInline.Head.finance_status == 0" style="width: 120px" size="mini" :value="$t('getapi[1901]')"
                                  :readonly="true" class="readO"></el-input>
                        <el-input v-if="formInline.Head.finance_status == 1" style="width: 120px" size="mini" :value="$t('getapi[3753]')"
                                  :readonly="true" class="readO"></el-input>
                        <el-input v-if="formInline.Head.finance_status == 2" style="width: 120px" size="mini" :value="$t('getapi[4606]')"
                                  :readonly="true" class="readO"></el-input>
                    </div>
                    <div class="bbl">
                        <span>{{ $t('getapi[143]') }}</span>
                        <el-input
                                type="textarea"
                                :rows="2"
                                v-model="formInline.Head.remark"
                                style="width: 480px"
                                :readonly="formInline.Head.order_status == 1 ? true : false"
                                :class="{'readO':formInline.Head.order_status == 1}"
                        ></el-input>
                    </div>
                </div>-->
                <div class="btnnowrap" style="margin-top:3px">
                    <el-button type="primary" icon="el-icon-circle-plus" size="mini" :disabled="!btn.addMaterials"
                               @click="addMaterials">{{$t('getapi[6092]')}}
                    </el-button>
                    <!-- <el-button type="primary" size="mini" :disabled="!btn.move" @click="exeMove" >{{$t('getapi[2434]')}}</el-button> -->
                    <el-button type="primary" size="mini" :disabled="!btn.finance" @click="exeKeep">
                        {{$t('getapi[2106]')}}
                    </el-button>
                    <!-- <el-button type="primary" size="mini" :disabled="!btn.setfdate" @click="ChangeFinaceDate" >{{$t('getapi[1870]')}}</el-button> -->
                </div>

                <!-- 右下表格-->
                <el-table
                        id="xdetilpane-0"
                        :data="formInline.Lists"
                        v-loading="loading"
                        header-row-class-name="headerclass"
                        :highlight-current-row="true"
                        stripe
                        border
                        :height="tableHeight - 180"
                        size="mini"
                        style="width: 100%; margin-top:3px"
                        @sort-change="sortChange"
                        :header-cell-style="$limits.headerClass"
                        ref="singleTable1">
                    <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')" sortable align="right"
                                     width="60"></el-table-column>
                    <el-table-column prop="part_code" :label="$t('getapi[112]')" sortable width="150">
                        <template slot-scope="scope">
                            <el-input v-if="editif"
                                      v-model="scope.row.part_code"
                                      @click.native.prevent="addMaterials()"
                                      :placeholder="$t('getapi[149]')"
                                      size="mini"
                                      readonly
                            ></el-input>
                            <span v-if="!editif">{{scope.row.part_code}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')" sortable
                                     width="100"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')" sortable
                                     width="80"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="source_cargo_position" :label="$t('getapi[2436]')" sortable
                                     width="100"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="source_cargo_type" :label="$t('getapi[2437]')" sortable
                                     width="100"></el-table-column>
                    <el-table-column prop="dest_cargo_position" :label="$t('getapi[2438]')" sortable
                                     width="150">
                        <template slot-scope="scope">
                            <el-input v-if="editif"
                                      v-model="scope.row.dest_cargo_position"
                                      @click.native.prevent="cargo(scope)"
                                      :placeholder="$t('getapi[2438]')"
                                      size="mini"
                                      readonly
                            ></el-input>
                            <span v-if="!editif">{{scope.row.dest_cargo_position}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="dest_cargo_type" :label="$t('getapi[2439]')" sortable
                                     align="right" width="100"></el-table-column>
                    <el-table-column prop="move_qty" :label="$t('getapi[2440]')" sortable align="right"
                                     width="100">
                        <template slot-scope="scope">
                            <el-input v-if="editif" v-model="scope.row.move_qty" :placeholder="$t('getapi[2440]')"
                                      type="number" autocomplete="off" title="" @mousewheel.native.prevent @input="sumss(scope, 0)" size="mini"></el-input>
                            <span v-if="!editif">{{scope.row.move_qty}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="assist_move_qty" :label="$t('getapi[2441]')" sortable
                                     align="right" width="100">
                        <template slot-scope="scope">
                            <el-input v-if="editif&&scope.row.assist_unit_flag" v-model="scope.row.assist_move_qty"
                                      :placeholder="$t('getapi[2441]')" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                      @change="getQty(scope)"></el-input>
                            <span v-if="!editif&&scope.row.assist_unit_flag">{{scope.row.assist_move_qty}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="qty_on_hand_qty" :label="$t('getapi[2442]')" sortable
                                     align="right" width="100"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="assist_on_hand_qty" :label="$t('getapi[2443]')" sortable
                                     align="right" width="100" v-if="showtab"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="measureunit" :label="$t('getapi[3100]')" align="right"
                                     width="100"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="assist_measureunit" :label="$t('getapi[130]')" sortable
                                     align="right" width="100" v-if="showtab"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="batch_no" :label="$t('getapi[1763]')" sortable align="right"
                                     width="100"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="sequence_no" :label="$t('getapi[1764]')" sortable align="right" width="100"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_groupid"   v-if="false"></el-table-column>                            
                    <el-table-column show-overflow-tooltip prop="freevalue" :label="$t('getapi[8958]')" sortable width="100" align="right"></el-table-column>              
                    <el-table-column show-overflow-tooltip prop="model" :label="$t('getapi[124]')" sortable align="right"
                                     width="100"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="specification" :label="$t('getapi[125]')" sortable align="right"
                                     width="100"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_stuff" :label="$t('getapi[126]')" sortable align="right"
                                     width="100"></el-table-column>                                     
                    <el-table-column show-overflow-tooltip prop="master_assist_rate" align="right" width="100"
                                     v-if="false"></el-table-column>
                    <el-table-column fixed="right" :label="$t('getapi[6048]')" width="60" align="center" v-if="editif">
                        <template slot-scope="scope">
                            <el-popconfirm
                                    :confirmButtonText="$t('getapi[1146]')"
                                    :cancelButtonText="$t('getapi[6]')"
                                    icon="el-icon-info"
                                    iconColor="red"
                                    :title="$t('getapi[637]')"
                                    @onConfirm="dellines(scope)"
                            >
                                <el-button slot="reference" type="text" size="small">{{ $t('getapi[40]') }}</el-button>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="InvMoveViewInfoInvMoveViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[985]')" queryData="InvMoveViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!-- 详情页面 -->
        <!-- <purordermanage :isVisible="isVisible" ref="order" @getdetail="getdetail"></purordermanage> -->
        <el-dialog v-dialogDrag :visible.sync="isShowEdit" :title="$t('getapi[6861]')" width="80%" @before-close="closemodel"
                   :close-on-click-modal="false">
			<span slot="footer" class="dialog-footer">
				<!-- <el-button @click="editvisi = false">{{ $t('getapi[6]') }}</el-button> -->
				<el-button type="primary" @click="sava" :loading="loading"
                           :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
        <!--销售件弹框 -->
        <salpart :isVisible="false" @getsalpart="getsalpart" ref="salinput"></salpart>
        <!-- 销售人员 -->
        <!--<employee :isVisible="false" @getemployee="getemployee" ref="inputemp"></employee>-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :selectType="3"
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getemployee"
                  ref="inputemp"></selector>
        <!-- 货位 -->
        <!--<cargo :isVisible="false" @getcargo="getcargo" ref="inpucar"></cargo>-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true
                  :postUrl="'Inv/Manager/GetCargoPositionDataList'" @callback="getcargo"
                  ref="inpucar"></selector>
        <!--物料选择 -->
        <!--<OM :isVisible="materialsVisible" @addmaterials="callbackmaterial" ref="inputmaterialtype"></OM>-->
        <selector :isVisible="materialsVisible" :isBatch=true :isSplitPage=true
                  :postUrl="'/Inv/Manager/GetEngPartDataList'" @callback="callbackmaterial"
                  ref="inputmaterialtype"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: 'InvMoveView',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                lineno: 0, //当前最大行号
                materialsVisible: false,
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('InvMoveView'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                isShowEdit: false, // 是否显示编辑页面
                PlanTypeArray: [], // 计划类型数组
                isEdit: true, // 是否新增操作
                editif: false,
                showtab: true, //是否显示次计量
                wcentershowindex: 0,
                formInline: {
                    Head: {
                        order_no: '',
                        order_status: 0,
                        keep_account_no: '',
                        keep_account_time: '',
                        keep_account_person: '',
                        dust_person: '',
                        move_time: '',
                        remark: '',
                        finance_status: 0,
                        finance_date: '',
                        order_type_flag: 0,
                        co_no: '',
                        concurrent_time: ''
                    },
                    Lists: []
                }, //详细数据
                oldFormInline: '',
                btn: {
                    //增加物料
                    addMaterials: false,
                    //执行移库
                    move: false,
                    //执行记账
                    finance: false,
                    //行删除
                    rowdel: false,
                    //调整财务日期
                    setfdate: false
                },
                oldrow: '',
                iscontinuedblclick: true,
                code: '',
                scrollTop:0,
                scrollTop1:0,
            };
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
            formInline: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(0)
                })
            }
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('InvMoveView', that)
            that.userData = sessionStorage.getItem('userData');
            that.PlanTypeArray = Array.methods.getPlanType();
            that.$limits.dragControllerDiv();
            that.oldFormInline = JSON.stringify(that.formInline)
            that.confirmAdd();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('InvMoveViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            callbackmaterial(data) {
                console.log("返回数据" + JSON.stringify(data));
                let that = this;
                that.lineno = 1;
                for (let i = 0; i < that.formInline.Lists.length; i++) {
                    if (that.formInline.Lists[i].line_no >= that.lineno) {
                        that.lineno = that.formInline.Lists[i].line_no + 1;
                    }
                }
                for (let i = 0; i < data.length; i++) {
                    that.formInline.Lists = [...that.formInline.Lists,{
                        relation_order_no: that.formInline.Head.order_no,
                        batch_no: data[i].batch_no,
                        sequence_no: data[i].sequence_no,
                        part_code: data[i].part_code,
                        part_name: data[i].part_name,
                        part_version: data[i].part_version,
                        model: data[i].part_model,
                        specification: data[i].part_spec,
                        part_stuff: data[i].part_stuff,                        
                        move_time: '',
                        source_cargo_position: data[i].cargo_position,
                        source_cargo_type: data[i].type_name,
                        dest_cargo_position: '',
                        dest_cargo_type: '',
                        measureunit: data[i].measureunit,
                        assist_measureunit: data[i].part_assist_unit,
                        move_qty: data[i].qty_on_hand,
                        assist_move_qty: data[i].assist_qty_on_hand,
                        line_no: that.lineno++,
                        qty_on_hand_qty: data[i].qty_on_hand,
                        assist_on_hand_qty: data[i].assist_qty_on_hand,
                        workproc_id: 0,
                        line_net_total_amount: 0,
                        unit_price: 0,
                        co_line_id: 0,
                        onhand_id: data[i].exclusively_id,
                        assist_unit_flag: data[i].assist_unit_flag,
                        master_assist_rate: data[i].master_assist_rate,
                        freevalue: data[i].freevalue,
                        part_groupid: data[i].part_groupid
                    }]
                }

            },
            addMaterials() {
                //弹框选择数据
                let that = this;
                that.materialsVisible = true;
                that.$refs.inputmaterialtype.clearInput(that.materialsVisible);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[985]"),this.$t("getapi[15]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
				let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
				let limits = 1;
                if(!this.$limits.menuvisible("plv2", 86, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 85, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 86, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 86, 1) == 2) {
                        if (that.$limits.authority('plv3', 86,1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 86,1) == 1) {
                            //编辑级
                            if (!that.$limits.fnIsEmpty(that.formInline.Head.order_no)) {
                                if (that.formInline.Head.order_status == 0) {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                            limits = 2;
                        }
                        if (that.$limits.authority('plv3', 86, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.formInline.Head.order_no)) {
                                if (that.formInline.Head.order_status == 1) {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                            limits = 3;
                        }
                    }
                }
				// that.$refs.SetBtn.InputBtnRight('T05_Quotation');
				if(limits==-1||limits==1)that.closeAllRightButton();
				else that.btnauthority();
            },
            btnauthority() {
                let that = this;
                //增加物料
                that.btn.addMaterials = false;
                //执行移库
                that.btn.move = false;
                //执行记账
                that.btn.finance = false;
                //行删除
                that.btn.rowdel = false;
                //调整财务日期
                that.btn.setfdate = false;
                if (that.$limits.fnIsEmpty(that.formInline.Head.order_no) || that.formInline.Head.order_status == 1) {
                    that.btn.move = false;
                } else {
                    that.btn.move = true;
                }
                if (!that.$limits.fnIsEmpty(that.formInline.Head.order_no)) {
                    if (that.formInline.Head.order_status == 0) {
                        that.btn.finance = false;
                        that.btn.rowdel = true;
                        that.btn.addMaterials = true;
                    } else {
                        that.btn.finance = true;
                        that.btn.rowdel = false;
                        that.btn.addMaterials = false;
                    }

                    switch (that.formInline.Head.finance_status) {
                        case -1:
                            that.btn.setfdate = true;
                            that.btn.finance = false;
                            break;
                        case 0: //核算
                            that.btn.setfdate = true;
                            that.btn.finance = true;
                            break;
                        case 1: //记账
                            that.btn.setfdate = true;
                            that.btn.finance = false;
                            break;
                        case 2: //月结
                            that.btn.setfdate = false;
                            that.btn.finance = false;
                            break;
                    }
                }
                else {
                    that.btn.addMaterials = true;
                }
                if(that.formInline.Head.order_status == 0 && that.formInline.Head.order_no != ''){
                    if(that.$limits.authority('plv4', 48, 1) == 1){
                        that.$refs.SetBtn.SetOneBtnEnable('execute', true);
                    } else {
                        that.$refs.SetBtn.SetOneBtnEnable('execute', false);
                    }
                }
			},
			closeAllRightButton(){
			let that =this;
			//增加物料
			that.btn.addMaterials=false;
			//执行移库
			that.btn.move=false;
			//执行记账
			that.btn.finance=false;
			//行删除
			that.btn.rowdel=false;
			},
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            edits(row) {
                let that = this;
                if(that.code == row.Order_No){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 86, 1)){
                        return
                    }
                    if(that.oldFormInline != JSON.stringify(that.formInline)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.Order_No
                                that.getdetail(row.Order_No);
                                that.isEdit = true;
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.Order_No
                        that.getdetail(row.Order_No);
                        that.isEdit = true;
                    }
                }, 100);
            },
            //弹出框关闭前提示
            closemodel(e) {
                let that = this
                this.$confirm(that.$t('getapi[3655]'), that.$t('getapi[194]'), {//'数据已发生变更是否保存后关闭?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                    })
                    .catch(() => {
                    });
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('InvMoveView',val)
                this.intidata();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.intidata();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'InvMoveViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.pageIndex = 1;
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.intidata();
            },
            // 库管员
            people() {
                let that = this;
                if (!that.editif) return;
                this.$refs.inputemp.clearInput(true);
            },
            // 获取
            getemployee(e) {
                this.formInline.Head.dust_person = e.name;
            },
            //目的货位
            cargo(row) {
                this.wcentershowindex = row.$index;
                let  param = {
                    part_code: row.row.part_code,
                    source_cargo_position: row.row.source_cargo_position
                }
                this.$refs.inpucar.clearInput(true, param);
            },
            //获取货位信息
            getcargo(e) {
                console.log(e);
                let that = this;
                that.formInline.Lists[that.wcentershowindex].dest_cargo_position = e.cargoposition_code;
                that.formInline.Lists[that.wcentershowindex].dest_cargo_type = e.type_name;
            },
            //根据次数量获取数量
            getQty(row) {
                let that = this
                let index = row.$index;
                that.formInline.Lists[index].move_qty = that.formInline.Lists[index].master_assist_rate * that.formInline.Lists[index].assist_move_qty;
            },
            //销售件弹框
            showwcenter(row) {
                console.log(row);
                this.wcentershowindex = row.$index;
                this.wcentervisible = true;
                this.$refs.salinput.clearInput(true, 5, '', '');
                this.addline(row.$index);
            },

            //获取销售件信息
            getsalpart(e) {
                console.log(e);
                // this.formInline.Lists[this.wcentershowindex] = e;
                this.formInline.Lists[this.wcentershowindex].assist_move_qty = e.assist_qty_on_hand;
                this.formInline.Lists[this.wcentershowindex].qty_on_hand_qty = e.qty_on_hand;
                this.formInline.Lists[this.wcentershowindex].source_cargo_position = e.cargo_position;
                this.formInline.Lists[this.wcentershowindex].assist_unit_flag = e.assist_unit_flag;
                this.formInline.Lists[this.wcentershowindex].batch_no = e.batch_no;
                this.formInline.Lists[this.wcentershowindex].measureunit = e.measureunit;
                this.formInline.Lists[this.wcentershowindex].assist_measureunit = e.part_assist_unit;
                this.formInline.Lists[this.wcentershowindex].part_code = e.part_code;
                this.formInline.Lists[this.wcentershowindex].model = e.part_model;
                this.formInline.Lists[this.wcentershowindex].part_name = e.part_name;
                this.formInline.Lists[this.wcentershowindex].specification = e.part_spec;
                this.formInline.Lists[this.wcentershowindex].part_stuff = e.part_stuff;                
                this.formInline.Lists[this.wcentershowindex].part_version = e.part_version;
                this.formInline.Lists[this.wcentershowindex].sequence_no = e.sequence_no;
                this.formInline.Lists[this.wcentershowindex].source_cargo_type = e.type_name;
                this.formInline.Lists[this.wcentershowindex].master_assist_rate = e.master_assist_rate;
                this.formInline.Lists[this.wcentershowindex].freevalue = e.freevalue;
                this.formInline.Lists[this.wcentershowindex].part_groupid = e.part_groupid;
                // exclusively_id: 67332
            },
            //计算
            sumss(e, tpe) {
            },
            //执行移库
            exeMove() {
                let that = this;
                if (that.formInline.Lists.length > 0) {
                    let parm = {
                        order_no: that.formInline.Head.order_no,
                        concurrent_time: that.formInline.Head.concurrent_time,
                        LangType:that.$processdata.getLang(),
                    };
                    console.log(parm);
                    that.$refs.SetBtn.SetOneBtnEnable('execute', false);
                    that.$http.urlpost('Inv/Manager/InvMoveAudit', parm, function (res) {
                        that.$refs.SetBtn.SetOneBtnEnable('execute', true);
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.getdetail(res.UniqueNum);
                            that.isShowEdit = false;
                            that.intidata();
                        }
                    });
                }
                // else{
                // 	that.$message.warning(that.$t('getapi[2459]'));
                // }
            },
            //执行记账
            exeKeep() {
            },
            //调整财务日期
            ChangeFinaceDate() {
            },
            // 数据一览
            intidata() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    Param: datac
                };
                console.log(data);
                that.$http.urlpost('/Inv/Manager/InvMoveView', data, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                });
            },
            //移库管理-根据移库单号获取移库单据信息
            getdetail(id) {
                let that = this;
                if (that.$limits.fnIsEmpty(id)) {
                    return;
                }
                let parm = {
                    Code: id
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('Inv/Manager/GetInvMoveBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.formInline = res.DataContent;
                        let allArray = that.formInline.Lists;
                        for (let i = 0; i < allArray.length; i++) {
                            if (that.lineno < allArray[i].line_no) that.lineno = allArray[i].line_no;
                            that.formInline.Lists[i].add = true;
                            if (that.formInline.Lists[i].assist_unit_flag == "False") that.formInline.Lists[i].assist_unit_flag = false;
                            else that.formInline.Lists[i].assist_unit_flag = true;
                        }

                        if (that.formInline.Head.order_status == 1) that.editif = false;
                        else that.editif = true;
                        that.oldFormInline = JSON.stringify(that.formInline)
                    }
                    that.authority();
                    loadingInstance.close()
                });
            },
            //保存数据
            sava() {
                let that = this;
                let parm = that.formInline;
                parm.LangType = that.$processdata.getLang()
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                parm.Lists.forEach(function (item, index) {
                    if (!item.add) {
                        parm.Lists.splice(index, 1);
                    }
                });
                that.$http.urlpost('Inv/Manager/InvMoveSaveData', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getdetail(res.UniqueNum);
                        that.isShowEdit = false;
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                that.getdetail(row.Order_No);
                that.isShowEdit = true;
                that.isEdit = true;
                //this.$refs.order.clearInput(this.isShowEdit, parm);
            },
            // 新增
            add() {
                let that = this;
                if(that.oldFormInline != JSON.stringify(that.formInline)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                that.editif = true;
                that.code = ''
                that.formInline = {
                    Head: {
                        order_no: '',
                        order_status: 0,
                        keep_account_no: '',
                        keep_account_time: '',
                        keep_account_person: '',
                        dust_person: '',
                        move_time: '',
                        remark: '',
                        finance_status: 0,
                        finance_date: '',
                        order_type_flag: 0,
                        co_no: '',
                        concurrent_time: ''
                    },
                    Lists: []
                };
                that.oldFormInline = JSON.stringify(that.formInline)
                //this.isShowEdit = true;
                that.authority();
                that.btnauthority();
            },
            //单据删除
            del() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            Code: that.formInline.Head.order_no
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del', false);
                        that.$http.urlpost('/Inv/Manager/InvMoveDeleteData', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del', true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.intidata();
                                that.confirmAdd();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //删除行
            dellines(e) {
                let line = e.$index;
                this.formInline.Lists.splice(line, 1);
            },
            //新增一行工艺清单
            addline(line) {
                let that = this;
                that.formInline.Lists[line].add = true;
                let detail = that.formInline.Lists;
                let deti = {
                    relation_order_no: '',
                    batch_no: '',
                    sequence_no: '',
                    part_code: '',
                    part_name: '',
                    part_version: '',
                    model: '',
                    specification: '',
                    part_stuff:'',
                    move_time: '',
                    source_cargo_position: '',
                    source_cargo_type: '',
                    dest_cargo_position: '',
                    dest_cargo_type: '',
                    measureunit: '',
                    assist_measureunit: '',
                    move_qty: 0,
                    assist_move_qty: 0,
                    line_no: that.formInline.Lists.length + 1,
                    qty_on_hand_qty: 0,
                    assist_on_hand_qty: 0,
                    workproc_id: 0,
                    line_net_total_amount: 0,
                    unit_price: 0,
                    co_line_id: 0,
                    onhand_id: 0,
                    assist_unit_flag: '',
                    master_assist_rate: 0
                };
                let jss = detail[detail.length - 1].add;
                if (jss) {
                    that.formInline.Lists.push(deti);
                }
            },
            //是否显示次计量单位
            cheshow(e) {
                console.log(e);
                this.showtab = e;
            },
            // 刷新
            reflash() {
                /*let that = this;
                that.intidata();
                if (!that.$limits.fnIsEmpty(that.formInline.Head.order_no)) {
                    that.getdetail(that.formInline.Head.order_no);
                }*/
                let that = this;
                if(that.oldFormInline != JSON.stringify(that.formInline)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.intidata();
                            if (!that.$limits.fnIsEmpty(that.formInline.Head.order_no)) {
                                that.getdetail(that.formInline.Head.order_no);
                            } else {
                                that.confirmAdd()
                            }
                        });
                } else {
                    that.intidata();
                    if (!that.$limits.fnIsEmpty(that.formInline.Head.order_no)) {
                        that.getdetail(that.formInline.Head.order_no);
                    } else {
                        that.confirmAdd()
                    }
                }
            },
            //删除
            delinfo(row) {
                console.log(row);
                let that = this;
                console.log(row.row.Order_No);
                let parm = {
                    Code: row.row.Order_No
                };
                that.$http.urlpost('Inv/Manager/InvMoveDeleteData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[659]'));
                        that.intidata();
                    }
                });
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('Inv/Manager/InvMoveExportExcel', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "InvMoveViewInfo",
                    fromname: that.$t('getapi[985]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                let parm = that.formInline;
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/Inv/Manager/InvMoveSaveData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.getdetail(res.UniqueNum);
                    }
                });
            },
            editInfo1() {
            },
            editInfo2() {
            },
            editInfo3() {
            },
            // 排序
            sortChange(column){
                let that = this
                that.$processdata.sortChange(column,that.formInline.Lists)
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 86,1) < 1){
                    return false
                }
                let flag =  that.oldFormInline != JSON.stringify(that.formInline)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .el-dropdown {
        vertical-align: top;
        background-color: #ffd04b !important;
        border-color: #ffd04b !important;
        color: #ffffff;
        margin-left: 20px;
        padding: 0 14px;
        border-radius: 5px;
    }

    .el-dropdown + .el-dropdown {
        margin-left: 15px;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }

    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }

    .box {
        width: 100%;
        .bbl {
            margin: 0px auto;
            white-space: pre;
            span {
                margin-left: 20px;
                width: 70px;
                text-align: left;
                line-height: 35px;
                display: inline-block;
            }
        }
    }

    span.titles {
        margin-left: 14px;
        margin-right: 15px;
        text-align: left;
        line-height: 40px;
        display: inline-block;
    }
</style>
